exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.common[data-v-4991fda2] {\n    padding: 20px 0px;\n    border-bottom: dotted 1px #e7e7e7;\n}\n.rule li[data-v-4991fda2] {\n   line-height: 25px;\n}\n.tips[data-v-4991fda2] {\n    margin-left: -25px;\n    color: #ea5858;\n}\n.common[data-v-4991fda2]:last-of-type {\n    border-bottom: none;\n    padding-bottom: 50px;\n}\n.special[data-v-4991fda2]{\n    color: rgb(79,128,189);\n    margin-top: 10px;\n}\nimg[data-v-4991fda2]{\n    width: 150px\n}\n", ""]);

// exports
